<div class="modal-header">
  <h3 class="modal-title" ngbAutofocus>{{viewerHeading}}</h3>
  <ng-select [items]="supportedLanguages" (change)="switchLanguage($event)" [clearable]="false"
    placeholder="{{ 'app.select-language' | translate }}" [(ngModel)]="selectedLanguage"></ng-select>
</div>

<div class="modal-body">
  <span class="date">{{ 'view.home.agreement.lastUpdate' | translate }}: {{ createdString }}</span>

  <quill-view [content]="viewerBody" format="html" theme="snow"></quill-view>

</div>

<div class="modal-footer" *ngIf="!preview">
  <input type="checkbox" [(ngModel)]="isChecked">
  <span>{{ 'view.home.agreement.accept' | translate }}</span>
  <button class="btn btn-primary" (click)="acceptAgreement()" role="button" [disabled]="!isChecked">
    {{ 'view.home.agreement.continue' | translate }}
  </button>
</div>

<div class="modal-footer" *ngIf="preview">
  <button class="btn btn-primary" (click)="close()" role="button">
    {{ 'view.home.agreement.close' | translate }}
  </button>
</div>
